import { CheckCircle, FlagOutlined } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { observer } from 'mobx-react';
import React, { useContext } from 'react';
import { Colors } from '../../../../../../../../design/color/Colors';
import { PassingContext } from '../../../../../PassingContext';

export interface IPassingNavigationItemProperties {
  title: string;
  passed: boolean;
  isActive: boolean;
  navigationRedirect: (title: string) => void;
}
export interface IPassingNavigationItemProps {
  title: string;
  passed: boolean;
  isActive: boolean;
  isActiveStep: boolean;
  pickedLang: string;
  navigationRedirect: (title: string) => void;
}
export const PassingPracticeNavigationItem = observer(
  ({ title, passed, navigationRedirect, isActiveStep, pickedLang }: IPassingNavigationItemProps) => {
    const { passingDomain } = useContext(PassingContext);
    if (!pickedLang) {
      return null;
    }

    const handleClick = () => {
      navigationRedirect(title);
      passingDomain.theoryDomain.onExpandIconClick('')
      passingDomain.theoryDomain.ui.activeStep.setValue(0);
    };

    return (
      <Box
        onClick={handleClick}
        sx={{
          padding: '4px 10px',
          display: 'flex',
          gap: '10px',
          color: Colors.textPrimary,
          cursor: 'pointer',
          '&:last-child': {
            marginBottom: '10px',
          },
        }}
      >
        {!passed ? (
          <FlagOutlined sx={{ color: isActiveStep ? Colors.primary : '' }} />
        ) : (
          <CheckCircle sx={{ color: isActiveStep ? Colors.primary : '' }} />
        )}
        <Typography sx={{ color: isActiveStep ? Colors.primary : '' }}>{title}</Typography>
      </Box>
    );
  },
);
